<template>
  <v-main class="d-flex align-center justify-center h-screen">
    <v-card width="1100" class="pa-4 error-card">
      <v-card-title class="screen-title">
        お探しのページが見つかりません
      </v-card-title>
      <v-card-text class="pt-4">
        ・削除されたか、アドレスが変更になっている可能性があります。<br />
        ・システム上、直接参照できないページにアクセスされた可能性があります。<br />
        ・入力したURLが正しくない可能性があります。
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn to="/login" color="primary" variant="flat">ログイン画面</v-btn>
      </v-card-actions>
    </v-card>
  </v-main>
</template>

<script lang="ts">
export default {
  name: "NotFoundView",
};
</script>
